<template>
  <div>
    <el-dialog
      :title="this.isCreated ? '新增礼包配置' : '编辑礼包配置'"
      center
      :visible="true"
      @close="onClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="701px"
    >
      <el-form
        ref="form"
        :model="form"
        label-width="100px"
        size="mini"
        style="margin-right: 50px"
      >
        <el-form-item label="支付项：" prop="payPoint">
          <pay-point-selector
            placeholder="请选择"
            @ready="onPayPointSelectorReady"
            @change="onPayPointSelectorChange"
            ref="payPointSelector"
          >
          </pay-point-selector>
        </el-form-item>
        <el-form-item label="限购次数：" prop="boughtTimesLimit">
          <el-input
            style="width: 120px"
            v-model="form.boughtTimesLimit"
          ></el-input>
        </el-form-item>
        <el-form-item label="商品：">
          <base-item-selector
            @updated="updatedItemSelector"
            v-model="form.rewards"
          ></base-item-selector>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="this.onClose">取消</el-button>
        <el-button type="primary" @click="submit()">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
const util = require("@/util");
import PayPointSelector from "@/components/PayPointSelector";
import BaseItemSelector from "../biz-components/BaseItemSelector";

// 本弹窗名称
const DialogName = "EditHeroUpgradeGiftDialog";
export default {
  data() {
    return {
      form: {
        rewards: [],
      },
      isCreated: false,
      itemSelectorResult: null,
    };
  },

  computed: {},

  async created() {
    let value = this.$dialogutil.getData(DialogName);
    if (value.entry != null) {
      this.form = value.entry;
    }
    this.isCreated = value.isCreated;
  },
  components: {
    PayPointSelector,
    BaseItemSelector,
  },

  methods: {
    /**
     * 编辑线上活动
     * @param {*} entry
     */
    async submit() {
      if (this.isCreated) {
        await this.add();
      } else {
        await this.update();
      }
    },

    async add() {
      try {
        // 弹确认框
        await this.$confirm(
          `确认新增（该操作不会真的保存配置，需要在上一级页面中保存）？`
        );

        let param = this.save();
        if (param.errMsg) {
          this.$message({
            message: param.errMsg,
            type: "error",
          });
          return;
        }
        this.$message({
          message: "新增成功",
          type: "success",
        });

        // 关闭当前对话框
        this.onCloseWhitParam(param);
      } catch (e) {}
    },
    async update() {
      try {
        // 弹确认框
        await this.$confirm(
          `确认修改（该操作不会真的保存配置，需要在上一级页面中保存）？`
        );

        let param = this.save();

        if (param.errMsg) {
          this.$message({
            message: param.errMsg,
            type: "error",
          });
          return;
        }
        this.$message({
          message: "修改成功",
          type: "success",
        });

        // 关闭当前对话框
        this.onCloseWhitParam(param);
      } catch (e) {}
    },

    save() {
      if (this.itemSelectorResult.errMsg) {
        return { errMsg: this.itemSelectorResult.errMsg };
      }

      let rewards = this.itemSelectorResult;

      let boughtTimesLimit = parseInt(this.form.boughtTimesLimit);
      if (
        isNaN(boughtTimesLimit) ||
        boughtTimesLimit < 0 ||
        boughtTimesLimit.toString() != this.form.boughtTimesLimit
      ) {
        return { errMsg: "限购次数非法" };
      }
      if (rewards.length == 0) {
        return { errMsg: "商品最少配置一项" };
      }

      return {
        payPoint: parseInt(this.form.payPoint),
        boughtTimesLimit: boughtTimesLimit,
        rewards: rewards,
      };
    },

    async onPayPointSelectorReady() {
      this.$refs.payPointSelector.payPoint = this.form.payPoint;
    },

    async onPayPointSelectorChange(newValue, oldValue) {
      this.form.payPoint = newValue;
    },

    async updatedItemSelector(param) {
      this.itemSelectorResult = param;
    },

    ms2ymdhm(ts) {
      return util.ms2ymdhm(ts);
    },

    onClose() {
      // 关闭当前对话框
      this.$dialogutil.close(DialogName);
    },
    onCloseWhitParam(param) {
      // 关闭当前对话框
      this.$dialogutil.close(DialogName, param);
    },
  },
};
</script>

<style lang="scss" scoped>
.switch-status-tag {
  display: inline-block;
  padding: 0 10px;
  border: 1px solid #d9ecff;
  border-radius: 4px;
}
.switch-status-tag-off {
  background-color: lightgray;
  border-color: lightgray;
}
.switch-status-tag-on {
  background-color: chartreuse;
  border-color: chartreuse;
}
</style>

